<template>
  <Invoice ref="Invoice" :order="selectedOrder" />
</template>

<script>
import Invoice from "@core/components/orders/invoice/Invoice.vue"
import { currencyFormat } from "@core/helpers/configHelper"

export default {
  name: "Complete",
  components: { Invoice },
  props: ["order"],
  data() {
    return {
      selectedOrder: null
    }
  },
  mounted() {
    const mapTable = products => {
      const temp = []
      products.forEach(item => {
        temp.push({
          image: item.product.media.length ? item.product.media.map(el => el.id) : [],
          imageThumbnail: item.product.media,
          name: item.product.name,
          sku: item.product.sku,
          price: currencyFormat(item.unit_price.amount),
          discount_price: item.discount_price,
          qty: item.qty,
          is_daily_deal: item.is_daily_deal,
          slug: item.product.slug,
          // total: currencyFormat(item.total.amount),
          total: currencyFormat(item.line_total.amount)
        })
      })
      return temp
    }
    this.order["productsTable"] = []
    this.order["productsTable"] = mapTable(this.order.order_products)
    this.order["shipping_method"] = (this.order.shipping_method && this.order.shipping_method.name) ? this.order.shipping_method.name : this.order.shipping_method
    this.selectedOrder = this.order
  }
}
</script>

<style scoped></style>
